import { useCallback } from 'react';
import { createContext, ReactNode, useContext, useState } from 'react';

type MuscleGroupData = {
  groups: string[];
  updateGroup: (value: string[]) => void;
};

export const MuscleGroupContext = createContext({} as MuscleGroupData);

type Props = {
  children: ReactNode;
};

export const MuscleGroupProvider = ({ children }: Props) => {
  const [groups, setGroup] = useState<string[]>([] as Array<string>);

  const updateGroup = useCallback((value: string[]) => {
    setGroup(value);
  }, []);

  return (
    <MuscleGroupContext.Provider
      value={{
        groups,
        updateGroup,
      }}
    >
      {children}
    </MuscleGroupContext.Provider>
  );
};

export const useMuscleGroup = (): MuscleGroupData => {
  const context = useContext(MuscleGroupContext);

  if (!context)
    throw new Error(`useMuscleGroup must be use within a muscleGroupProvider!`);

  return context;
};
